import { Col, Form, Input, Row } from 'antd'
import { lazy } from 'react'

import { withSuspense } from '@/hoc/WithSuspense'
import TithiSection from '../TithiSection'
import S3Upload from '@a4b/ui/src/modules/monetisation/puja/molecules/S3Upload'
import { PUJA_PRESIGN_URL, YODA_CDN_URL } from '@/utils/constants'
import ContentSection from '../ContentSection'
import IntentGenerationBanner from '../IntentGenerationBanner'
import InfluencerRecommendationBanner from '../InfluencerRecommendationBanner'

const InfoMedia = lazy(() => import('../InfoMedia'))
const PreviousPoojaMedia = lazy(() => import('../PreviousPoojaMedia'))
const BannerItems = lazy(() => import('../BannerItems'))
const TodayImportance = lazy(() => import('../TodayImportance'))
const SrimandirService = lazy(() => import('../SrimandirService'))
const GlimpsesOfServices = lazy(() => import('../GlimpsesOfServices'))
const AssociatedTemples = lazy(() => import('../AssociatedTemples'))
const PreviousOrderRecommendations = lazy(() => import('../PreviousOrderRecommendations'))
const BannerLarge = lazy(() => import('../BannerLarge'))
const SanakalpBanner = lazy(() => import('../SankalpBanner'))
const HighlightedPooja = lazy(() => import('../HighlightedPooja'))
const InfoMediaWeb = lazy(() => import('../InfoMediaWeb'))
const FestivalHeroSection = lazy(() => import('../Mahakumbh/FestivalHeroSection'))
const FestivalSMExperience = lazy(() => import('../Mahakumbh/FestivalSMExperience'))
const ValueProps = lazy(() => import('../Mahakumbh/ValueProps'))
const FestivalTrustMarker = lazy(() => import('../Mahakumbh/FestivalTrustMarker'))
const FestivalServices = lazy(() => import('../Mahakumbh/FestivalServices'))
const AllServices = lazy(() => import('../Mahakumbh/AllServices'))
const TextSection = lazy(() => import('../TextSection'))
const TopCategoriesStatic = lazy(() => import('../TopCategoriesStatic/TopCategoriesStatic'))


type ComponentType =
    | 'info_media'
    | 'info_media_web'
    | 'previous_pooja_media'
    | 'banner_items'
    | 'today_importance'
    | 'srimandir_services'
    | 'glimpses_of_services'
    | 'associated_temples'
    | 'associated_pilgrims'
    | 'previous_order_recommendation_card'
    | 'banner_large'
    | 'highlighted_pooja'
    | 'sankalp_banner'
    | 'festival_hero_section'
    | 'festival_sm_experience'
    | 'value_props'
    | 'festival_trust_marker'
    | 'festival_services'
    | 'all_services'
    | 'text_section'
    | 'top_categories_static'
    | 'tithi_section'
    | 'content_section'
    | 'intent_generation_banner'
    | 'influencer_recommendation_banner'

interface RenderComponentProps {
    cdnUrl: string
    preSignUrl: string
    form: any
    storeList?: any[]
    getInventoryList?: (storeId: string) => void
    inventoryList?: any[]
    basePath?: (string | number)[] | any
}

export const renderSectionComponent = (type: ComponentType, props: RenderComponentProps, form?: any) => {
    switch (type) {
        case 'info_media': {
            return (
                (<Form.List name={[...props?.basePath, "info_media"]}>
                    {(fields, { add, remove, move }) => (
                        withSuspense(<InfoMedia fields={fields} add={add} remove={remove} move={move} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'info_media'} basePath={props?.basePath} />)
                    )}
                </Form.List>)
            )
        }
        case 'info_media_web':
            return (
                withSuspense(<InfoMediaWeb cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'info_media_web'} basePath={props?.basePath} />)
            )
        case 'previous_pooja_media':
            return (
                <Form.List name={[...props?.basePath, 'media_cards']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<PreviousPoojaMedia fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} />)
                    )}
                </Form.List>
            )
        case 'banner_items':
            return (
                <>
                    <Form.List name={[...props?.basePath, 'pooja_items']}>
                        {(fields, { add, remove }) => (
                            withSuspense(<BannerItems fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type='Add Pooja Items' />)
                        )}
                    </Form.List>
                    <Form.List name={[...props?.basePath, 'offering_items']}>
                        {(fields, { add, remove }) => (
                            withSuspense(<BannerItems fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type='Add Offering Items' />)
                        )}
                    </Form.List>
                </>
            )
        case 'today_importance':
            return withSuspense(<TodayImportance storeList={props?.storeList} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} basePath={props?.basePath} />)
        case 'srimandir_services':
            return (
                <Form.List name={[...props?.basePath, 'srimandir_services']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<SrimandirService fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} />)
                    )}
                </Form.List>
            )
        case 'glimpses_of_services':
            return (
                <Form.List name={[...props?.basePath, 'media_cards']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<GlimpsesOfServices fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} datatype='Glimpses of services' />)
                    )}
                </Form.List>
            )
        case 'associated_temples':
        case 'associated_pilgrims':
            return (
                <Form.List name={[...props?.basePath, 'media_cards']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<AssociatedTemples fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} datatype={type === 'associated_temples' ? 'Associated temples' : 'Associated pilgrims'} />)
                    )}
                </Form.List>
            )
        case 'previous_order_recommendation_card':
            return (
                <Form.List name={[...props?.basePath, 'banner_large_items']}>
                    {(fields) => (
                        withSuspense(<PreviousOrderRecommendations fields={fields} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} />)
                    )}
                </Form.List>
            )
        case 'banner_large':
            return (
                <Form.List name={[...props?.basePath, 'banner_large']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<BannerLarge fields={fields} add={add} remove={remove} cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} datatype='Banner Large' />)
                    )}
                </Form.List>
            )
        case 'highlighted_pooja':
            return (
                <Form.List name={[...props?.basePath, 'highlighted_pooja']}>
                    {(fields, { add, remove, move }) => (
                        withSuspense(<HighlightedPooja
                            onSortEnd={({ oldIndex, newIndex }) => {
                                console.log('oldIndex', oldIndex, 'newIndex', newIndex)
                                move(oldIndex, newIndex)
                            }}
                            distance={1}
                            helperClass='sortableHelper'
                            form={props?.form}
                            fields={fields}
                            add={add}
                            remove={remove}
                            cdnUrl={props?.cdnUrl}
                            preSignUrl={props?.preSignUrl}
                            datatype='Highlighted Pooja'
                        />)
                    )}
                </Form.List>
            )
        case 'sankalp_banner':
            return (
                <Form.List name={[...props?.basePath, 'sankalp_banner_items']}>
                    {(fields, { add, remove }) => (
                        withSuspense(<SanakalpBanner fields={fields} add={add} remove={remove} storeList={props?.storeList} getInventoryList={props?.getInventoryList} inventoryList={props?.inventoryList} />)
                    )}
                </Form.List>
            )
        case 'festival_hero_section':
            return (
                withSuspense(<FestivalHeroSection cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'festival_hero_section'} formInstance={props?.form} basePath={props?.basePath} />)
            )
        case 'festival_sm_experience':
            return (
                withSuspense(<FestivalSMExperience cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'festival_sm_experience'} basePath={props?.basePath} />)
            )
        case 'value_props':
            return (
                withSuspense(<ValueProps cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'value_props'} basePath={props?.basePath} />)
            )
        case 'festival_trust_marker':
            return (
                withSuspense(<FestivalTrustMarker cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'festival_trust_marker'} basePath={props?.basePath} />)
            )
        case 'festival_services':
            return (
                withSuspense(<FestivalServices cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'festival_services'} basePath={props?.basePath} />)
            )
        case 'all_services':
            return (
                withSuspense(<AllServices cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'all_services'} basePath={props?.basePath} />)
            )
        case 'text_section':
            return (
                withSuspense(<TextSection basePath={props?.basePath} />)
            )
        case 'top_categories_static':
            return (
                withSuspense(<TopCategoriesStatic type='top_categories_static' basePath={props?.basePath} />)
            )
        case 'tithi_section':
            return (
                <div style={{
                    border: '1px dashed #e0dcdc',
                    marginRight: '0px',
                    width: '100%',
                    padding: '10px',
                }}>
                    <div style={{ marginTop: '20px' }}>
                        <strong>Tithi Section:</strong>
                        <Form.Item
                            label={`Background Image Url`}
                            name={[...props?.basePath, 'bg_img_url']}
                            labelCol={{ span: 32 }}
                            wrapperCol={{ span: 32 }}
                            rules={[
                                {
                                    required: true,
                                    min: 0,
                                    max: 1,
                                    validator: async (rules: any, values: any) => {
                                        if (values?.length < rules.min) {
                                            return Promise.reject(' Background Image Url')
                                        }
                                    },
                                },
                            ]}
                            valuePropName='fileList'
                        >
                            <S3Upload
                                cdnUrl={YODA_CDN_URL}
                                preSignUrl={PUJA_PRESIGN_URL}
                                min={0}
                                max={1}
                            />
                        </Form.Item>
                        <Form.List name={[...props?.basePath, 'cards']}>
                            {(fields, { add, remove }) => (
                                <TithiSection
                                    form={props?.form}
                                    fields={fields}
                                    add={add}
                                    remove={remove}
                                    cdnUrl={props?.cdnUrl}
                                    preSignUrl={props?.preSignUrl}
                                    datatype={'tithi_section'} />
                            )}
                        </Form.List>
                    </div></div>)
        case 'content_section':
            return (
                <div style={{
                    border: '1px dashed #e0dcdc',
                    marginRight: '0px',
                    width: '100%',
                    padding: '10px',
                }}>
                    <div style={{ marginTop: '20px' }}>
                        <strong>Content Section:</strong>
                        <Row gutter={16} align="middle">
                            {/* Image Upload */}
                            <Col span={15}>
                                <Form.Item
                                    label="title"
                                    name={[...props?.basePath, "title"]}
                                    rules={[{ required: true, message: "Enter Title" }]}
                                >
                                    <Input placeholder="Enter Title" />
                                </Form.Item>
                            </Col>
                            <Col span={15}>
                                <Form.Item
                                    label="See More Text"
                                    name={[...props?.basePath, "see_more_text"]}
                                // rules={[{ required: true, message: "Enter See More Text" }]}
                                >
                                    <Input placeholder="Enter See More Text" />
                                </Form.Item>
                            </Col>

                            {/* Deeplink Input */}
                            <Col span={24}>
                                <Form.Item
                                    label="See More Deeplink"
                                    name={[...props?.basePath, "see_more_deeplink"]}
                                    rules={[{ required: true, message: "Enter See More Deeplink" }]}
                                >
                                    <Input placeholder="Enter See More Deeplink" />
                                </Form.Item>
                            </Col>

                        </Row>
                        <Form.List name={[...props?.basePath, 'cards']}>
                            {(fields, { add, remove }) => (
                                <ContentSection
                                    form={props?.form}
                                    fields={fields}
                                    add={add}
                                    remove={remove}
                                    cdnUrl={props?.cdnUrl}
                                    preSignUrl={props?.preSignUrl}
                                    datatype={'content_section'} />
                            )}
                        </Form.List>
                    </div></div>)
        case 'intent_generation_banner':
            return (
                withSuspense(<IntentGenerationBanner cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'intent_generation_banner'} basePath={props?.basePath} />)
            )
        case 'influencer_recommendation_banner':
            return (
                withSuspense(<InfluencerRecommendationBanner cdnUrl={props?.cdnUrl} preSignUrl={props?.preSignUrl} type={'influencer_recommendation_banner'} basePath={props?.basePath} />)
            )
        default:
            return null
    }
}